import Notification from "app/models/Notification";
import { FaCheck, FaTimes, FaPencilAlt, FaExternalLinkAlt } from "react-icons/fa";
import { IconContext } from "react-icons";
import { Link } from "react-router-dom";
import NotificationData from "app/models/Notification";

interface TileNotificationProps {
    notification: Notification;
}
const notificationStatuses = [
    {
        status: "CANCELLED",
        icon: <FaTimes />,
        text: "È stata annullata la Corsa",
    },
    {
        status: "ASSIGNED",
        icon: <FaCheck />,
        text: "Ti è stata assegnata la Corsa",
    },
    {
        status: "MODIFIED",
        icon: <FaPencilAlt />,
        text: "È stata modificata la Corsa",
    },
];

const getIcon = (status: string) => {
    return notificationStatuses.find(i => i.status === status)?.icon;
}

const getLabel = (status: string) => {
    return notificationStatuses.find(i => i.status === status)?.text;
}

const notificationTimestampFormat = (timestamp: string) => {
    const notificationTimestamp = new Date(timestamp);
    const today = new Date()
    const isTimestampToday = (notificationTimestamp.toDateString() === today.toDateString());

    // Mostro ore e minuti se la notifica è di oggi
    if (isTimestampToday) {
        return new Intl.DateTimeFormat('it-IT', { hour: '2-digit', minute: '2-digit' }).format(notificationTimestamp);
    }

    // Mostro giorno e mese se la notifica è almeno di ieri
    return new Intl.DateTimeFormat('it-IT', { month: '2-digit', day: '2-digit' }).format(notificationTimestamp);
}

export default function TileNotification({ notification }: TileNotificationProps) {
    const notificationData = notification?.data as NotificationData;
    return (
        <a href={notificationData.target_url}>
            <div className={(notification?.read_at ? '' : 'active')}
                style={{
                    backgroundColor: notification?.read_at ? "#FAFAFA" : "rgb(239, 218, 167)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 20px",
                }}>
                {/*
                <div className={"notification-icon " + notificationData?.status?.toLowerCase()}>
                    <IconContext.Provider value={{ className: "" }}>
                        {getIcon(notificationData.status)}
                    </IconContext.Provider>
                </div>
                <div className="notification-type">{getLabel(notificationData?.status)}</div>
                */}
                <div className="notification-time">
                    <p className="w-full">{notificationTimestampFormat(notification?.created_at) ?? ""}</p>
                </div>
                <div className="notification-content">
                    <p className="notification-title">{notificationData?.title ?? ""}</p>
                    <div className="notification-description">
                        <p>{ notificationData?.message ?? ""}</p>
                    </div>
                </div>
                {/*
                    notificationData?.status !== "CANCELLED" &&
                    notificationData?.ride_id &&
                    <div className="ride-link">
                        <Link to={`/ride/${notificationData?.ride_id}`}>
                            <FaExternalLinkAlt />
                        </Link>
                    </div>
                    */ }
            </div>

        </a>
    )
}


